export default {
	field: 'memo',
	name: 'Memo',
}
